import React, { Component } from "react";
import "../Styles/LocationStyle.css";
import StaffPic from "../Images/Staff.jpg";

export class Location extends Component {
  displayName = this.name;

  render() {
    return (
      <div>
        <div className="container">
          <div className="row">
            <h1 style={{ textAlign: "center" }}>Where To Find Us</h1>
          </div>

          <div className="row">
            <div className="col-md-4">
              <h3 style={{ textAlign: "center" }}>
                13436 Jefferson Hwy.
                <br />
                Baton Rouge, LA. 70817
                <br />
                Phone: 225-756-0662
              </h3>
              <div className="mapouter">
                <div className="gmap_canvas">
                  <iframe
                    title="location"
                    width="auto"
                    height="300"
                    id="gmap_canvas"
                    src="https://maps.google.com/maps?q=13436%20Jefferson%20Hwy%20Baton%20Rouge&t=&z=15&ie=UTF8&iwloc=&output=embed"
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                    marginWidth="0"
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="row">
                <h3 style={{ textAlign: "center" }}>
                  <u>Hours of Operation</u>
                </h3>
                <table className="location-table">
                  <tbody>
                    <tr>
                      <td className="location-td">Monday - Thursday</td>
                      <td className="location-td">4:15 AM - 10:00 PM</td>
                    </tr>
                    <tr>
                      <td className="location-td">Friday</td>
                      <td className="location-td">4:15 AM - 9:00 PM</td>
                    </tr>
                    <tr>
                      <td className="location-td">Saturday</td>
                      <td className="location-td">8:00 AM - 4:00 PM</td>
                    </tr>
                    <tr>
                      <td className="location-td">Sunday</td>
                      <td className="location-td">10:00 AM - 6:00 PM</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="row">
                <h3 style={{ textAlign: "center" }}>
                  <u>Childcare Hours</u>
                </h3>
                <table className="location-table">
                  <tbody>
                    <tr className="location-tr">
                      <td className="location-td">Monday - Friday</td>
                      <td className="location-td">8:30 AM - 1:00 PM</td>
                    </tr>
                    <tr className="location-tr">
                      <td className="location-td"></td>
                      <td className="location-td">4:00 PM - 8:00 PM</td>
                    </tr>
                    <tr className="location-tr">
                      <td className="location-td">Saturday</td>
                      <td className="location-td">8:30 AM - 1:00 PM</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-md-4">
              <div className="row" style={{ textAlign: "center" }}>
                <h3 style={{ textAlign: "center" }}>
                  <u>Staff</u>
                </h3>
                <p className="staff-text">Donnie Calloway - Owner</p>
                <p className="staff-text">Callie Calloway - General Manager </p>
                <p className="staff-text">
                  Conner Calloway - Assistant Manager
                </p>
                <p className="staff-text">
                  Mauri Capello - Group Fitness Manager
                </p>
                <img src={StaffPic} alt="Staff" style={{ maxWidth: "300px" }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Location.js